import { LogOut } from 'lucide-react';
import { Suspense } from 'react';
import { Outlet } from 'react-router';
import logo from '@/assets/logo.png';
import { useSignout } from '@/hooks/auth';

export const AppLayout = () => {
  const { mutate: signout } = useSignout();

  return (
    <div className="flex flex-col min-h-screen bg-neutral-100">
      <header className="bg-zinc-800 h-11 flex items-center justify-between px-5">
        <img src={logo} alt="アニマルオフィス" className="h-8 w-auto" />
        <button
          type="button"
          onClick={() => signout()}
          className="text-white/60 hover:text-white duration-300 cursor-pointer"
          title="ログアウト"
        >
          <LogOut className="size-5" />
        </button>
      </header>
      <main className="flex-1">
        <Suspense>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
};
